module.exports = __webpack_public_path__ + "static/media/bsc.d8e9b0e1.svg";